import {useContext} from "react";
import UserContext from "../context/UserContext";

function Profile() {
    const {users, setUsers} = useContext(UserContext);
    const handleLogin = () => {
        setUsers({...users, id: 2, usernames: "mur"})
    };
    return (
        <div>
            
           
            <div className="flex flex-col mt-96  gap-4 ml-10 "></div>
            <p></p>
            kullanıcı: {users.id};
            <p>
            user: {users.usernames};
            </p>
            <p>
            place: {users.placeSide};
            </p>
            <p>
            firm: {users.firm_sub_code}
            </p>
            <button onClick={handleLogin}>Logins</button>
            <code>{JSON.stringify(users)}</code>

        </div>
        
    )
}

export default Profile;